import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap-5';

export default class AvailableIntegrationsCard extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    currentDatabase: PropTypes.object.isRequired,
    databases: PropTypes.array.isRequired,
    image: PropTypes.string.isRequired,
    integration: PropTypes.object,
    name: PropTypes.string,
    toolTipId: PropTypes.string.isRequired,
    onConnect: PropTypes.func.isRequired,
  };

  render() {
    const { children, image, name } = this.props;

    return (
      <React.Fragment>
        <hr className="my-2"/>
        <div className="d-flex flex-column flex-md-row align-items-start">
          <div className="flex-shrink-0 px-4">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt={name ? `${name} integration icon` : 'Integration icon'} height={36} src={image} width={36} />
            </div>
          </div>
          <div className="flex-grow-1">
            {children}
          </div>
          {this.renderConnectionButton()}
        </div>
      </React.Fragment>
    );
  }

  renderConnectionButton() {
    const { currentDatabase, integration, databases, toolTipId, onConnect } = this.props;
    const databaseId = integration ? integration.databaseId : null;
    const connectedDatabase = databases.find(t => t.id === databaseId);

    if (databaseId) {
      let message;

      if (connectedDatabase && currentDatabase.id === databaseId) return;

      if (connectedDatabase) {
        message = `You currently have this integration synced with ${connectedDatabase.name}. ` +
          `Disconnect from that database if you wish to connect to ${currentDatabase.name}.`;
      } else {
        message = `You currently have this integration synced with ${integration.databaseName}, ` +
          `an inactive database. Disconnect from that database if you wish to connect to ${currentDatabase.name}.`;
      }

      const connectedToolTip = (
        <Tooltip id={toolTipId} placement="top">
          <span>{message}</span>
        </Tooltip>
      );

      return (
        <div className="d-flex justify-content-end">
          <OverlayTrigger overlay={connectedToolTip} placement="top">
            <span className="d-inline-block mt-2">
              <Button
                className="d-inline-flex align-items-center"
                disabled
                size="sm"
                variant="dark"
              >
                <FontAwesomeIcon icon={faPlus}/>
                <span>Connect</span>
              </Button>
            </span>
          </OverlayTrigger>
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-end mt-2">
          <Button
            className="d-inline-flex align-items-center"
            size="sm"
            variant="dark"
            onClick={onConnect}
          >
            <FontAwesomeIcon icon={faPlus}/>
            <span>Connect</span>
          </Button>
        </div>
      );
    }
  }
}
